import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'modal-input-error-msg',
  templateUrl: './modal-input-error-msg.component.html',
  styleUrls: ['./modal-input-error-msg.component.scss']
})
export class ModalInputErrorMsgComponent {

  @Input() errorMessage: string;
  @Input() control?: FormControl;
  @Input() condition?: boolean;

}
